import { createActions } from 'reduxsauce';

export interface IPayoutsState {
  data: IPayoutsData[];
  isLoading: boolean;
  error: string;
}
export type ReportType = 'STRIPE_PAYOUT' | 'QUARTERLY_SUMMARY';

export interface IPayoutsData {
  payout_date: string;
  report_id: string;
  report_type: ReportType;
  quarter_label: string | null;
}

export interface PayoutsTypes {
  PAYOUTS: 'PAYOUTS';
  PAYOUTS_START: 'PAYOUTS_START';
  PAYOUTS_SUCCESS: 'PAYOUTS_SUCCESS';
  PAYOUTS_ERROR: 'PAYOUTS_ERROR';
  PAYOUTS_CLEAN_UP: 'PAYOUTS_CLEAN_UP';
}

const { Types, Creators } = createActions<PayoutsTypes>({
  payouts: ['data'],
  payoutsStart: null,
  payoutsSuccess: ['data'],
  payoutsError: ['error'],
  payoutsCleanUp: null,
});

export { Types };

export default Creators;
